<template>
    <div class="bg-gray2 pb-2">
        <ob1-liens-haut-bas
            class="container-fluid py-2"
            :button-id="'legal-mentions-header'"
            :collapsed-block-id="'legal-mentions-text'"
            :button-label="title"
        >
            <div v-if="pxfLegalMentionsText">
                <div class="fw-bold small" v-html="pxfLegalMentionsText" />
            </div>
            <legal-mentions4x-cb
                v-if="cb4xLegalMentionsText"
                :label="cb4xLegalMentionsText"
                :popin4x-cb="popin4xCb"
            />
            <div v-if="generalLegalMentions" class="small" v-html="generalLegalMentions" />
        </ob1-liens-haut-bas>
    </div>
</template>

<script>

import LegalMentions4xCb from "./LegalMentions4xCb.vue";

export default {
    name: "LegalMentionsDevice",
    components: {LegalMentions4xCb},
    props: {
        title: {
            type: String,
            required: true
        },
        generalLegalMentions: {
            type: String,
            default: null,
            required: false
        },
        pxfLegalMentionsText: {
            type: String,
            default: null,
            required: false
        },
        cb4xLegalMentionsText: {
            type: String,
            default: null,
            required: false
        },
        popin4xCb: {
            type: Object,
            default: null,
            required: false
        }
    }
}
</script>
